export const LOAN_PAYMENT_FORM_PAYERS = 'payers'
export const LOAN_PAYMENT_FORM_AMOUNT = 'amount'
export const LOAN_PAYMENT_FORM_PAYED_ON = 'payedOn'
export const LOAN_PAYMENT_FORM_DESCRIPTION = 'description'



// WEBPACK FOOTER //
// ./src/constants/LoanPaymentFormFieldName.tsx